import { Component } from '@angular/core';

@Component({
  selector: 'app-egyptions',
  templateUrl: './egyptions.component.html',
  styleUrl: './egyptions.component.scss'
})
export class EgyptionsComponent {

}
